export default {"src":"/_next/static/media/elevator.422beb89.svg","height":100,"width":100};